import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import LabelField from '../../components/plain/LabelField';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldReference from '../../components/plain/FieldReference';
import FieldRefList from '../../components/plain/FieldRefList';
import FieldString from '../../components/plain/FieldString';
import FieldList_TableGroup from '../../components/plain/FieldList_TableGroup';
import FieldList_CardsPanel from '../../components/plain/FieldList_CardsPanel';
import SelectMerchantsModal from '../../modal/SelectMerchantsModal';
import SelectTerminalsModal from '../../modal/SelectTerminalsModal';

import { ORGANIZATION_PATH, BOOKSHOP_PLAIN_PATH } from '../../util/routes';
import { FORM_ORGANIZATION_TABLE } from '../../util/consts/forms';
import { ENUMERATION_AREA } from '../../util/consts/common';
import { getUserInfo } from '../../util/localStorage';
import { getDefinedValue } from '../../util/tools';
import { IET_ADD_LIST_ITEM } from '../../util/realm/instance';
import { performApiRequest, ACTION_EBOOK_SUPPLIER_GET_TERMINALS_API_URL, ACTION_EBOOK_SUPPLIER_GET_MERCHANTS_API_URL
} from '../../util/restapi';

import iconAccept from '../../assets/icons/png24x24/Accept.png';
import iconInsert from '../../assets/icons/png24x24/insert.png';
import iconDelete from '../../assets/icons/png24x24/Delete.png';

class EBookSupplierPlainPage extends PlainPage { 

	enumArea = null;
	userInfo = null;
	activeMerchant = null;
	mapTerminals = new Map();
	// mapTerminals.has(key)
		
	constructor(props) {
		super(props);
		this.refSelectMerchantsModal = React.createRef();
		this.refSelectTerminalsModal = React.createRef();
		this.refTerminalList = React.createRef();
		
		this.formPath = 'ebook_supplier_plain';
		this.formTitle = 'Розповсюджувач за програмою "єКнига"';
		this.userInfo = getUserInfo();
		
		this.state.isSelectMerchantsModalOpen=false;
		this.state.isSelectTerminalsModalOpen=false;
	}
	componentDidMount = async () => {
		this.init('EBookSupplier')
		document.title = 'BOM. ' + this.formTitle;
	}
	completeInit = async () => {
		if( this.instance.id == null ) {
			this.instance.rootField.value.state.value = 'registered';
		}
		this.instanceReadOnly =
			( ! this.userInfo.permission.superuser ) && 
			( this.instance.rootField.value.state.value === 'accepted' )
		this.enumArea = this.realm.getEnumeration( ENUMERATION_AREA );
		return true;
	}
	
	openSelectMerchantsModal = () => {
		this.setState({isSelectMerchantsModalOpen: true});
	}
	closeSelectMerchantsModal = () => {
		this.setState({isSelectMerchantsModalOpen: false});
	}
	selectMerchants = ( listMerchant ) => {
		//console.log('selectMerchants', listMerchant)
		let instance = this.state.instance;
		let fieldMerchants = instance.rootField.value.merchantList;
		let itemModel = fieldMerchants.model.item;
		for( let m of listMerchant ) {
			let item = instance.createObjectField( itemModel, m );
			instance.addListItem(fieldMerchants, item);
		}
	}
	openSelectTerminalsModal = (fieldMerchant) => {
		this.activeMerchant = fieldMerchant;
		this.setState({isSelectTerminalsModalOpen: true});
	}
	closeSelectTerminalsModal = () => {
		this.setState({isSelectTerminalsModalOpen: false});
	}
	selectTerminals = ( listTerminal ) => {
		if( this.activeMerchant == null )
			return;
		let instance = this.state.instance;
		let fieldTerminals = this.activeMerchant.value.terminalList;
		let itemModel = fieldTerminals.model.item;
		for( let t of listTerminal ) {
			let item = instance.createObjectField( itemModel, t );
			instance.addListItem(fieldTerminals, item);
		}
	}
	
	handleInstanceChange(event) {
		super.handleInstanceChange(event);
		let instance = this.state.instance;
		if( event.eventType == IET_ADD_LIST_ITEM ) {
			let fieldId = event.field.model.fieldId;
			if( fieldId == 'merchantList' ) {
				let fieldStatus = event.field.value[ event.index ].value.status;
				instance.setFieldValue(fieldStatus, 'actual');
			}
			if( fieldId == 'terminalList ' ) {
				let fieldStatus = event.field.value[ event.index ].value.status;
				instance.setFieldValue(fieldStatus, 'actual');
			}
		}
	}
	validateInstance() {
		let instance = this.state.instance;
		let fieldMerchants = instance.rootField.value.merchantList;
		for(let i=0, size=fieldMerchants.value.length; i < size; i++) {
			let merch = fieldMerchants.value[i];
			if( ! merch.value.mid.value || ! merch.value.acquirerRef.value || ! merch.value.mcc.value ) {
				let msg = 'Мерчант ' + (i+1) + ' (' + this.createMerchantCard(merch) + '): необхідно заповнити поля  ' 
				let first = true;
				if( ! merch.value.acquirerRef.value ) {
					if( first )
						first = false;
					else
						msg += ', ';
					msg += '"Еквайр"'
				}
				if( ! merch.value.mid.value ) {
					if( first )
						first = false;
					else
						msg += ', ';
					msg += '"MID"'
				}
				if( ! merch.value.mcc.value ) {
					if( first )
						first = false;
					else
						msg += ', ';
					msg += '"MCC"'
				}
				return msg;
			}
			for(let j=0, size2=merch.value.terminalList.value.length; j < size2; j++) {
				let term = merch.value.terminalList.value[j];
				if( ! term.value.tid.value ) {
					let terminalCard = this.createTerminalCard(term);
					let msg = 'Мерчант ' + (i+1) + ' (' + this.createMerchantCard(merch) + '), ' +
					'термінал ' + (j+1) + ' (' + terminalCard + '): необхідно заповнити полe  '
					let first = true;
					if( ! term.value.tid.value ) {
						if( first )
							first = false;
						else
							msg += ', ';
						msg += '"Термінал"'
					}
					return msg;
				}
			}
		}
		return null;
	}

	createMerchantCard(fieldMerchant) {
		//console.log('fieldMerchant', fieldMerchant)
		let card = '';
		if( fieldMerchant.value.acquirerRef.value && fieldMerchant.value.acquirerRef.value.card)
			card += fieldMerchant.value.acquirerRef.value.card;
		card += ' - '
		if( fieldMerchant.value.mid.value )
			card += fieldMerchant.value.mid.value;
		card += ' - '
		if( fieldMerchant.value.mcc.value )
			card += fieldMerchant.value.mcc.value;
		return card;
	}
	merchantCardBuilderHtml = (fieldMerchant, index) => {
		let card = this.createMerchantCard(fieldMerchant);
		let cardColor = 'black'
		let status = fieldMerchant.value.status.value;
		if( status == 'devoid' )
			cardColor = 'rgb(128,128,128';
		return <div style={{color: cardColor}}>{card}</div>;
	}
	onMerchantRowClick = (merchantIndex) => {
		if( this.refTerminalList.current && merchantIndex >= 0 ) {
			let instance = this.state.instance;
			let fieldMerchant = instance.rootField.value.merchantList.value[ merchantIndex ];
			this.refTerminalList.current.updateFieldMerchant( fieldMerchant );
		}
	}
	createTerminalCard(fieldTerminal) {
		let card = '';
		if( fieldTerminal.value.bankCode.value )
			card += fieldTerminal.value.bankCode.value;
		card += ' - '
		if( fieldTerminal.value.tid.value )
			card += fieldTerminal.value.tid.value;
		return card;
	}

	createMerchantPanel = (activeField, listItemInfo) => {
		console.log('createMerchantPanel', activeField)
		return (
			<MerchantPanel plain={this} instance={this.state.instance} 
				fieldGroup={activeField} listItemInfo={listItemInfo} 
			/>
		);		
	}

	renderBody() {
		var refOrganizationNodes = [
			{
				classId: 'Organization', plainFormPath: ORGANIZATION_PATH, 
				selectInstanceFormId: FORM_ORGANIZATION_TABLE,
				selectInstanceFormTitle: 'Організація'
			}
		]
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<div style={{display: 'flex', alignItems: 'center'}}>
						<FieldReference instance={this.state.instance} path={'/orgRef'} plain={this}
							refNodes={refOrganizationNodes} 
							styles={{divMain: {marginRight: '30px'}}}
							readOnly={ ! this.userInfo.permission.superuser && this.instanceReadOnly } 
						/>
						<FieldEnum instance={this.state.instance} path={'/state'} plain={this} styleSelect={{}}
							readOnly={ ! this.userInfo.permission.superuser } 
						/>
					</div>
					
					<div style={{marginTop: '20px', marginRight: '10px'}}>
						{/* itemComponent={MerchantPanel} */}
						{/* buildItemComponent={this.createMerchantPanel} */}
						<MerchantList path={'/merchantList'} instance={this.instance}
							plain={this} itemComponent={MerchantPanel} disableMoveItems={true}
							itemCardHtmlBuilder={this.merchantCardBuilderHtml}
							onRowClick={this.onMerchantRowClick}
							readOnly={ ! this.userInfo.permission.superuser && this.instanceReadOnly } 
							styles={{
								divCardsBlock: {
									marginRight: '10px',
									minWidth: '400px',
									maxWidth: '400px',
								},
								divCardList: {
									maxHeight: '400px',
									overflowY: 'scroll'
								},
								divCard: {
									marginTop: '3px',
									padding: '7px',
									cursor: 'pointer',
									minHeight: '18px'
								}
							}}
						/>
					</div>
					
					<div style={{marginTop: '10px'}}>
						<div>
							<LabelField instance={this.state.instance} path={'/comment'} />
						</div>
						<div>
							<FieldString instance={this.state.instance} path={'/comment'} plain={this}
								multiline={true} rows={5} cols={60} styleInput={{width: '99%'}}
								readOnly={ ! this.userInfo.permission.superuser && this.instanceReadOnly } 
							 />
						</div>
					</div>			
				</div>
				<SelectMerchantsModal ref={this.refSelectMerchantsModal} plain={this} />
				<SelectTerminalsModal ref={this.refSelectTerminalsModal} plain={this} />
			</div>
		)
	}
}

class MerchantList extends FieldList_CardsPanel {
	
	changeStatus = () => {
		let instance = this.props.instance;
		let index = this.state.selectedIndex;
		if( index < 0 || index >= this.field.value.length )
			return;
		let fieldStatus = this.field.value[index].value.status; 
		if( fieldStatus.value == 'devoid' )
			instance.setFieldValue(fieldStatus, 'actual');
		else
			instance.setFieldValue(fieldStatus, 'devoid');
		this.setState({ dirtyCounter: this.state.dirtyCounter+1});
	}
	appendMerchants = async () => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let orgRef = instance.rootField.value.orgRef.value;
		if( ! orgRef || ! orgRef.id )
			return;
		let request = {orgId: orgRef.id}
		
		let response = await performApiRequest(ACTION_EBOOK_SUPPLIER_GET_MERCHANTS_API_URL, request);
		if( ! response.success ) {
			plain.props.app.showResponse( response, 'Merchant list load error' );
			return;
		}
		let listMerchant = response.listMerchant;
		
		for(let i=listMerchant.length-1; i >= 0;  i--) {
			let m = listMerchant[i];
			let ignore = false;
			for(let instanceMerchant of instance.rootField.value.merchantList.value) {
				if( instanceMerchant.ref.id == m.id ) {
					ignore = true;
					break;
				}
			}
			if( ignore ) {
				listMerchant.splice(i,1);
			}
		}
		if( listMerchant.length == 0 ) {
			let message = {
				title: 'Увага',
				mainMessage: 'Перелік мерчантів пустий'
			};
			plain.props.app.showMessage( message );
			return;
		}
		
		plain.refSelectMerchantsModal.current.init(listMerchant);
		plain.openSelectMerchantsModal();
//		console.log( 'listMerchant', listMerchant );
	}
	
	createHeaderHtml() {
		let userInfo = this.props.plain.userInfo;
		let isSuperUser = userInfo.permission.superuser;
		let labelEmptyHtml = null;
		let divHeaderStyle = {display: 'flex', alignItems: 'center', marginBottom: '5px', width: '100%'};
		let readOnly = getDefinedValue( this.props.readOnly, false);
		let buttonDeleteHtml = null;
		if( isSuperUser ) {
			buttonDeleteHtml = 
				<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
					title={'Вилучити мерчанта з переліку мерчантів постачальника'} 
					onClick={this.deleteItem} disabled={readOnly}
				>
					<img src={iconDelete} />
				</button>
		}
		let headerHtml = (
			<div style={divHeaderStyle}>
				{this.createTitleHtml()}
				{labelEmptyHtml}
				<div style={{display: 'flex'}}>
					{/*this.createButtonAddHtml()*/}
					{this.createMoveItemsButtonsHtml()}
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
						onClick={this.changeStatus} disabled={readOnly} title={'Змінити статус мерчанта'}
					>
						<img src={iconAccept} />
					</button>
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
						onClick={this.appendMerchants} disabled={readOnly} title={'Додати мерчантів з переліку'}
					>
						<img src={iconInsert} />
					</button>
					{buttonDeleteHtml}
				</div>
			</div>
		);
		return headerHtml;
	}
}

class MerchantPanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}
	
	createMarkHeader = (columnId) => {
		if( columnId == 'mark' ) {
			return <div></div>
		} else 
			return null;
	}
	createTerminalCell = (columnId, rowIndex, instance, itemField, plain, plainDirtyCounter) => {
		let status = itemField.value.status.value;
		let userInfo = plain.userInfo;
		if( columnId == 'mark' ) {
			if( status == 'devoid' ) {
				return <div></div>
			} else {
				return <div><img src={iconAccept} /></div>
			}
		} else if( status == 'devoid' && ! userInfo.permission.superuser ) {
			let value = '';
			if( columnId == 'tid' ) {
				value = itemField.value.tid.value;
			} else if(  columnId == 'comments' ) {
				value = itemField.value.comments.value;
			}
			return <div style={{color: 'gray'}}>{value}</div>
		} else
			return null;
	}
	
	render() {
		let fieldGroup = this.props.fieldGroup;
		let plain = this.props.plain;
		let instance = this.props.instance;
		
		let status = fieldGroup.value.status.value;
		let readOnly = plain.instanceReadOnly || (( status == 'devoid' ));
		let terminalReadOnly = plain.instanceReadOnly || (( status == 'devoid' ));
		if( plain.userInfo.permission.superuser ) {
			readOnly = false;
			terminalReadOnly = false;
		}
		readOnly = true;
		
		return (
			<div style={{flexGrow: '1', backgroundColor: 'lightGray'}}>
				<div style={{border: '1px solid green', margin: '10px 10px 10px 10px', padding: '10px'}}>
					<div style={{display: 'flex', alignItems: 'center'}}>
						{/* новий варіант */}	
						<FieldRefList path={'acquirerRef'} instance={instance} plain={plain} readOnly={readOnly} 
							parentField={fieldGroup} classId={'EBookBank'} styles={{ select: { width: '370px', marginRight: '20px'}}} 
						/>
						<FieldString path={'mid'} instance={instance} parentField={fieldGroup} plain={plain}
							styles={{ input: { width: '170px', marginRight: '20px'}} }
							readOnly={ readOnly } 
						 />
						<FieldEnum path={'mcc'} instance={instance} parentField={fieldGroup} plain={plain} 
							styles={{ select: { width: '100px'} }} 
							readOnly={ readOnly } 
						/>
					</div>
					{/* 
					<div style={{marginTop: '15px'}}>
						<TerminalList instance={instance} path={'terminalList'} parentField={fieldGroup}
							plain={plain} plainDirtyCounter={plain.state.plainDirtyCounter} disableMoveItems={true} 
							readOnly={readOnly} terminalReadOnly={terminalReadOnly} 
							createDataCellComponent={this.createTerminalCell} createHeaderCellComponent={this.createMarkHeader}
							table={{
								columns: [
									{ columnId: 'mark', styles: {tdHeader: {width: '5%'}} },
									{ columnId: 'tid', styles: {tdHeader: {width: '20%'}} },
									{ columnId: 'comments', styles: {tdHeader: {width: '75%'}} },
								],
							}}
							styles={{
								table: {width: '100%'},
								trHeader: {height: '40px'}
							}}
						/>
					</div>
					*/}
					<div style={{marginTop: '15px'}}>
						<ListTerminal ref={plain.refTerminalList} plain={plain} />
					</div>
				</div>
			</div>
		)
	}
}

class ListTerminal extends React.Component {
	
	fieldMerchant = null;
	
	constructor(props) {
		super(props);
		this.state = {status: 'init', listTerminal: [], initErrorMessage: ''};
	}
	componentDidMount() {
		let instance = this.props.plain.instance;
		let fieldMerchantList = instance.rootField.value.merchantList; 
		if( fieldMerchantList.value.length > 0 ) {
			let fieldMerchant = fieldMerchantList.value[0];
			this.updateFieldMerchant( fieldMerchant ); 
		}
	}
	
	updateFieldMerchant = async (fieldMerchant) => {
		this.setState({status: 'init', listTerminal: []})
		this.fieldMerchant = fieldMerchant;
		console.log('updateFieldMerchant', fieldMerchant);
		let plain = this.props.plain;
		let merchantId = fieldMerchant.ref.id;
		if( ! plain.mapTerminals.has(merchantId) ) {
			let bookShopId = 0;
			let acquirerId = 0;
			if( this.fieldMerchant.value.bookShopRef.value )
				bookShopId = this.fieldMerchant.value.bookShopRef.value.id;
			if( this.fieldMerchant.value.acquirerRef.value )
				acquirerId = this.fieldMerchant.value.acquirerRef.value.id;
			let request = {
				bookShopId: bookShopId,
				acquirerId: acquirerId,
				bankCode: this.fieldMerchant.value.bankCode.value,
			}
			let response = await performApiRequest(ACTION_EBOOK_SUPPLIER_GET_TERMINALS_API_URL, request);
			if( response.success ) {
				plain.mapTerminals.set(merchantId, response.listTerminal)
			} else {
				plain.mapTerminals.set(merchantId, response.message)
			}
		}
		
		let listTerminal = plain.mapTerminals.get(merchantId);
		if( Array.isArray(listTerminal) ) {
			this.setState({status: 'initComplete', listTerminal: listTerminal})
		} else {
			this.setState({status: 'initError', initErrorMessage: listTerminal})
		}
	}
	
	render() {
		let plain = this.props.plain;
		let merchantId = 0;
		if( this.fieldMerchant )
			merchantId = this.fieldMerchant.ref.id;
		let listTerminal = plain.mapTerminals.get(merchantId);
		
		if( this.state.status == 'init' || ! plain.mapTerminals.has(merchantId))
			return (<div>...</div>);
		if( this.state.status == 'initError' )
			return (<div>{this.state.initErrorMessage}</div>);

		let terminalRowsHtml = listTerminal.map( (terminal, index) => {
			let refBookShop = terminal.bookShopRef;
			let bookShopCard = null;
			if( refBookShop != null ) {
				let url = BOOKSHOP_PLAIN_PATH + '/' + refBookShop.id; 
				bookShopCard = <a href={url}>{refBookShop.card}</a>
			} 
			return <tr key={index}><td>{terminal.tid}</td><td>{bookShopCard}</td><td>{terminal.comments}</td></tr>
		} );
		
		return (
			<table border='1' style={{width: '100%'}}>
			<thead>
				<tr>
					<td style={{width: '20%'}}>Ід.термінала</td>
					<td>Книгарня</td>
					<td>Примітки</td>
				</tr>
			</thead>
			<tbody>
				{terminalRowsHtml}
			</tbody>
			</table>
		);
	}
}

class TerminalList extends FieldList_TableGroup {
		
	changeStatus = () => {
		let instance = this.props.instance;
		let index = this.state.selectedIndex;
		if( index < 0 || index >= this.field.value.length )
			return;
		let fieldStatus = this.field.value[index].value.status; 
		if( fieldStatus.value == 'devoid' )
			instance.setFieldValue(fieldStatus, 'actual');
		else
			instance.setFieldValue(fieldStatus, 'devoid');
		this.setState({ dirtyCounter: this.state.dirtyCounter+1});
	}
	appendTerminals = async () => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let orgRef = instance.rootField.value.orgRef.value;
		if( ! orgRef || ! orgRef.id )
			return;
		let request = {orgId: orgRef.id}
		let response = await performApiRequest(ACTION_EBOOK_SUPPLIER_GET_TERMINALS_API_URL, request);
		if( ! response.success ) {
			plain.props.app.showResponse( response, 'No terminals' );
			return;
		}
		let listTerminal = response.listTerminal;
		for(let i=listTerminal.length-1; i >= 0;  i--) {
			let t = listTerminal[i];
			let ignore = false;
			for(let merchant of instance.rootField.value.merchantList.value) {
				for(let instanceTerminal of merchant.value.terminalList.value) {
					if( instanceTerminal.ref.id == t.id ) {
						ignore = true;
						break;
					}
				}
				if( ignore )
					break;
			}
			if( ignore ) {
				listTerminal.splice(i,1);
			}
		}
		if( listTerminal.length == 0 ) {
			let message = {
				title: 'Увага',
				mainMessage: 'Всі термінали постачальника вже задіяні'
			};
			plain.props.app.showMessage( message );
			return;
		}
		
		plain.refSelectTerminalsModal.current.init(listTerminal);
		plain.openSelectTerminalsModal(this.props.parentField);
	}
	
	createHeaderHtml() {
		let userInfo = this.props.plain.userInfo;
		let isSuperUser = userInfo.permission.superuser;
		let labelEmptyHtml = null;
		let divHeaderStyle = {display: 'flex', alignItems: 'center', marginBottom: '5px', width: '100%'};
		let readOnly = getDefinedValue( this.props.terminalReadOnly, false);
		let buttonDeleteHtml = null;
		if( isSuperUser ) {
			buttonDeleteHtml = 
				<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
					onClick={this.deleteItem} disabled={readOnly} title={'Вилучити термінал з переліку терміналів мерчанта'}
				>
					<img src={iconDelete} />
				</button>
		}
		let headerHtml = (
			<div style={divHeaderStyle}>
				{this.createTitleHtml()}
				{labelEmptyHtml}
				<div style={{display: 'flex'}}>
					{/*this.createButtonAddHtml()*/}
					{this.createMoveItemsButtonsHtml()}
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
						onClick={this.changeStatus} disabled={readOnly} title={'Змінити статус термінала'}
					>
						<img src={iconAccept} />
					</button>
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
						onClick={this.appendTerminals} disabled={readOnly} title={'Вибрати термінал з переліку'}
					>
						<img src={iconInsert} />
					</button>
					{buttonDeleteHtml}
				</div>
			</div>
		);
		return headerHtml;
	}
}

export default EBookSupplierPlainPage;
